import React, { useEffect, useState } from 'react';
import NavigationDrawer from './components/NavigationDrawer';
import { Outlet } from 'react-router-dom';

const DashboardLayout: React.FC = () => {
  useEffect(() => {
    document.title = "LinkPlease - Dashboard";
  }, []);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="flex h-screen bg-[#F5F4FA] relative">
      {/* Mobile Navigation Header */}
      <div className="lg:hidden w-full bg-white fixed top-0 left-0 px-4 py-3 shadow-sm">
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="p-2 hover:bg-gray-100 rounded-lg"
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M4 6h16M4 12h16M4 18h16"
            />
          </svg>
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div
          className="z-20 fixed inset-0 bg-black bg-opacity-50  lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Navigation Drawer - Hidden on mobile by default */}
      <div
        className={`z-20 fixed lg:relative lg:flex w-64 h-full bg-white transform transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
      >
        <NavigationDrawer />
      </div>
      
      {/* Main Content Area */}
      <main className="flex-1 overflow-auto lg:p-6 mt-14 lg:mt-0 p-1">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;